import DataProvider from "../DataProvider.js";

/**
 * Validates a zone's customID and panel_id to ensure their uniqueness.
 *
 * @param {Object} values - The form values containing customID, OrganizationId, and panel_id.
 * @returns {Object} errors - An object containing error messages if validation fails.
 */
const validateZone = async (values) => {
  const errors = {};

  // Destructure relevant fields from the form values.
  const { customID, OrganizationId, panel_id, id } = values;

  // Validation logic
  const validate = async () => {
    try {
      // Modify filter to also check panel_id
      const filter = { customID, OrganizationId, panel_uid: panel_id };

      // Fetch zones with matching criteria
      const zones = await DataProvider.getList("zones", {
        pagination: {},
        sort: { field: "customID", order: "ASC" },
        filter,
      });

      // Check if a zone exists with the same customID and panel_id
      if (zones.data && zones.data.some((zone) => zone.id !== id)) {
        errors.customID = `The combination of ID ${customID} and Panel ID ${panel_id} is not unique within the selected organization.`;
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Invoke validation logic if customID is present
  if (customID && panel_id) await validate();
  return errors;
};

export default validateZone;
